import { useQuery } from "@tanstack/react-query";
import { getConfigObject, useBaseResult } from "../../../utils/utils";
import { ProviderControllerApi } from "../../../services";

/**
 * @author rajkumar rathod
 */
export const useProviderProfile = (
  tenantId?: string,
  enabled?: boolean
): useBaseResult<any> =>
  useQuery({
    queryKey: ["provider-profile", tenantId, enabled],
    enabled:
      (tenantId !== null || tenantId !== undefined || tenantId !== "none") &&
      (enabled ?? true),
    refetchOnWindowFocus: false,
    // staleTime: Infinity,
    queryFn: async () =>
      new ProviderControllerApi(getConfigObject())
        .getProfile(tenantId as string)
        .then((res) => res?.data),
  });
